import { render } from "./CustomSetting.vue?vue&type=template&id=3967ff9a&ts=true"
import script from "./CustomSetting.vue?vue&type=script&lang=ts"
export * from "./CustomSetting.vue?vue&type=script&lang=ts"

import "./CustomSetting.vue?vue&type=style&index=0&id=3967ff9a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__